module.exports = __webpack_public_path__ + "img/teachers-hw.f21c61e3.png";